export default "__VITE_ASSET__BgnQx8fE__"